/**
 * Keep theme account links on /account — Klaviyo Customer Hub rewrites them to #k-hub.
 * Registered at parse time (capture phase) so we run before Klaviyo's handlers.
 */
(function () {
  var ACCOUNT_URL = window.wonderlyAccountUrl || '/account';

  function isAccountNavigationLink(link) {
    if (!link || link.tagName !== 'A') return false;

    if (
      link.matches('.header .header__icon--account, .menu-drawer__account, [data-wonderly-account-link]')
    ) {
      return true;
    }

    if (!link.closest('.footer')) return false;

    var href = (link.getAttribute('href') || '').trim();
    if (!href || href === '#') return false;
    if (href === '#k-hub' || href.indexOf('#k-hub') !== -1) return true;
    if (href.indexOf('/account') !== -1) return true;

    return false;
  }

  function accountUrlFor(link) {
    return link.getAttribute('data-account-url') || ACCOUNT_URL;
  }

  function navigateToAccount(link) {
    window.location.assign(accountUrlFor(link));
  }

  function repairAccountLink(link) {
    if (!isAccountNavigationLink(link)) return;

    var target = accountUrlFor(link);
    if (link.getAttribute('href') !== target) {
      link.setAttribute('href', target);
    }

    if (link.dataset.wonderlyAccountBound === 'true') return;
    link.dataset.wonderlyAccountBound = 'true';

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (link.getAttribute('href') !== target) {
          link.setAttribute('href', target);
        }
      }).observe(link, {
        attributes: true,
        attributeFilter: ['href'],
      });
    }
  }

  function scanAccountLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a').forEach(function (link) {
      repairAccountLink(link);
    });
  }

  function init() {
    scanAccountLinks(document);

    var observeTargets = [
      document.querySelector('.header__icons'),
      document.querySelector('.footer'),
      document.querySelector('.menu-drawer__utility-links'),
    ].filter(Boolean);

    if ('MutationObserver' in window) {
      observeTargets.forEach(function (target) {
        new MutationObserver(function () {
          scanAccountLinks(target);
        }).observe(target, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['href', 'class'],
        });
      });
    }

    window.setTimeout(function () {
      scanAccountLinks(document);
    }, 500);
    window.setTimeout(function () {
      scanAccountLinks(document);
    }, 2500);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a');
      if (!isAccountNavigationLink(link)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      navigateToAccount(link);
    },
    true
  );

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#k-hub') {
      window.location.assign(ACCOUNT_URL);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.location.hash === '#k-hub') {
    window.location.assign(ACCOUNT_URL);
  }
})();
